export function _excelExport(content) {
  // Decode base64 using atob method
  var raw = window.atob(content);
  // Create an array to store the decoded data
  var uInt8Array = new Uint8Array(raw.length);
  // blob can only receive binary encoding, need to talk about base64 converted to binary and then stuffed
  for (var i = 0; i < raw.length; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  // A return value is given here. In other methods, you can get the converted blob by using the base64 encoding.
  const link = document.createElement("a");
  const blob = new Blob([uInt8Array], { type: "application/vnd.ms-excel" });
  link.style.display = "none";
  link.href = URL.createObjectURL(blob);
  // Set the downloaded Excel table name
  link.setAttribute("download", "MdtRapor");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return null;
}
